export const AUTH_ROUTE_PATH = {
  auth: {
    login: {
      path: "/login",
    },
    register: {
      path: "/register",
    },
  },
};
